module.exports = __webpack_public_path__ + "e42220af2a635a4b74b23c5ae0d05584.pdf";